module.exports = __webpack_public_path__ + "img/rebecca-roanhorse.0b565113.png";